function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.667h30v13.333H0v-13.333Z",
    style: {
      fill: "#0b4ea2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.333h30v6.667H0v-6.667Z",
    style: {
      fill: "#ee1c25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M12.994,9.85s.156,1.558.156,4.675c-.022,3.183-2.403,4.794-4.15,5.642-1.747-.847-4.128-2.458-4.15-5.642,0-3.117.156-4.675.156-4.675h7.988Z",
    style: {
      fill: "#ee1c25"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.647,18.333v-3.897c-1.319,0-1.694.117-2.089.236.037-.398.037-.799,0-1.197.394.119.769.236,2.089.236v-1.083c-.417,0-.992.017-1.653.242.037-.399.037-.801,0-1.2.661.222,1.236.239,1.653.239,0-.314-.097-.989-.219-1.547.381.034.764.034,1.144,0-.122.558-.219,1.233-.219,1.547.417,0,.992-.017,1.653-.239-.037.399-.037.801,0,1.2-.661-.225-1.236-.242-1.653-.242v1.083c1.319,0,1.694-.117,2.089-.236-.037.398-.037.799,0,1.197-.394-.119-.769-.236-2.089-.236v3.897h-.706Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.994,9.85s.156,1.558.156,4.675c-.022,3.183-2.403,4.794-4.15,5.642-1.747-.847-4.128-2.458-4.15-5.642,0-3.117.156-4.675.156-4.675h7.988Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.842,21.397c-.778,0-1.408-1.079-1.408-2.409s.631-2.408,1.409-2.408c.322,0,.635.189.886.536.556-1.304,1.576-1.525,2.279-.493.099.145.188.31.266.493.605-.837,1.491-.677,1.981.357s.396,2.55-.209,3.387c-.251.347-.563.536-.886.536h-4.318Z",
    style: {
      fill: "#0b4ea2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,20.333l-.065-.032c-1.177-.571-2.083-1.218-2.768-1.979-.963-1.07-1.457-2.347-1.467-3.796,0-3.089.155-4.675.156-4.691l.014-.135h8.26l.013.135c.002.016.156,1.602.156,4.69-.01,1.45-.504,2.728-1.467,3.797-.685.761-1.591,1.409-2.768,1.979l-.064.032ZM5.143,10c-.036.441-.143,1.961-.143,4.525.017,2.367,1.325,4.159,4,5.475,2.675-1.316,3.983-3.107,4-5.476,0-2.563-.107-4.083-.143-4.524h-7.714Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/SK.fe4a38cea0bbb9edf500c9b397dc8944.svg";
export { ForwardRef as ReactComponent };